<router-outlet></router-outlet>

<app-confirm-popup></app-confirm-popup>

<p-toast></p-toast>
<app-toast></app-toast>